import React, { useState } from 'react';
import { Button, Card, Checkbox, FormField, Heading, majorScale, Pane, TextInput } from 'evergreen-ui';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { LoadUserFromGoogleDialog } from '../../../../../components/dialogs';
import { SelectSnipeAssetDialog } from '../../../../../components/dialogs'
import { SelectCompanyID } from '../../../../../components/inputs'
import { useSelector } from 'react-redux';

const SnipeCheckoutAssetForm = ({ submit }) => {
  const [allowEdit, setAllowEdit] = useState(false);
  const role = useSelector((state) => state.authentication.user.role);
  const isAdmin = role.name === 'Administrator';
  const formik = useFormik({
    initialValues: {
      email: '',
      asset_id: '',
      company_id: null,
    },
    onSubmit: (values) => submit(values),
    validationSchema: Yup.object().shape({
      email: Yup.string().required('Email is required').email('Must be a valid email'),
      asset_id: Yup.number().required('Asset is required'),
      company_id: Yup.number().required('You must select a Company to continue'),
    }),
    validateOnChange: false,
  });
  const { values, errors, handleChange } = formik;

  const loadGoogleUser = (user) => {
    if (user) {
      formik.setFieldValue('email', user.email);
    }
  };

  const selectSnipeAsset = (selectedAsset) => {
    if (selectedAsset) {
      formik.setFieldValue('asset_id', selectedAsset.id);
    }
  };

  const selectCompanyID = (companyID) => {
    if (companyID) {
      formik.setFieldValue('company_id', companyID);
    }
  };

  return (
    <Pane>
      <form onSubmit={formik.handleSubmit}>
        <Card border="default" marginBottom={majorScale(2)} paddingX={majorScale(2)} backgroundColor="white">
          <Pane
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            paddingY={majorScale(2)}
            borderBottom="1px solid #edeff5">
            <Pane>
              <Heading size={600}>Checkout Snipe asset to selected user</Heading>
            </Pane>
            <Pane>
              <LoadUserFromGoogleDialog onSelect={loadGoogleUser} />
            </Pane>
          </Pane>

          <Pane paddingBottom={majorScale(1)} paddingTop={majorScale(1)}>
            <FormField
              label="Company"
              marginTop={majorScale(2)}
              maxWidth="50%"
              validationMessage={formik.errors.company_id}>
              <SelectCompanyID
                value={formik.values.company_id}
                onSelect={selectCompanyID}
                isAdmin={isAdmin}
              />
            </FormField>
          </Pane>

          <Pane paddingBottom={majorScale(2)}>
            <FormField
              label="Email"
              marginTop={majorScale(1)}
              maxWidth="20%"
              validationMessage={errors.email}>
              <Checkbox
              label="Enter email account manually"
              checked={allowEdit}
              onChange={(e) => setAllowEdit(e.target.checked)} />

              <TextInput
                data-testid="email"
                name="email"
                width="100%"
                onChange={handleChange}
                value={values.email}
                readOnly={!allowEdit}
                isInvalid={errors.email && true} />
            </FormField>
            <FormField label="Asset ID" validationMessage={errors.asset_id} paddingTop={majorScale(2)}>
              <Pane display="flex" alignItems="center">
                <TextInput
                  value={values.asset_id}
                  readOnly
                  width={120}
                  marginRight={majorScale(1)}
                />
                <SelectSnipeAssetDialog
                  onSelect={selectSnipeAsset}
                  company_id={values.company_id}
                />
              </Pane>
            </FormField>
          </Pane>
        </Card>
        <Card
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          backgroundColor="white"
          padding={majorScale(2)}
          border>
          <Button type="button" disabled={formik.isSubmitting}>
            Cancel
          </Button>

          <Button
            marginLeft={majorScale(2)}
            appearance="primary"
            type="submit"
            isLoading={formik.isSubmitting}
            disabled={!formik.isValid}>
            Submit
          </Button>
        </Card>
      </form>
    </Pane>
  );
};

export default SnipeCheckoutAssetForm;
